import { toaster } from '@/components/ui/toaster';
import api from '@/libs/axiosInstance';
import type { ApiResponse } from '@fluenceur/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const removeFromWishlist = async (id: string): Promise<ApiResponse> => {
  const response = await api.delete<ApiResponse>(`/dashboard/wishlist/${id}`);
  return response.data;
};

export const useRemoveFromWishlistAction = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse, AxiosError<ApiResponse>, string>({
    mutationFn: removeFromWishlist,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wishlist'] });

      toaster.success({
        title: t('wishlist.actions.removeSuccess.title'),
        description: t('wishlist.actions.removeSuccess.description'),
      });
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || t('common.errors.unexpected');

      toaster.error({
        title: t('wishlist.actions.removeError.title'),
        description: errorMessage,
      });
    },
  });
};
